module.exports = __webpack_public_path__ + "static/media/hz_tu2box.c0139c31.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hz_tu2box.png
// module id = 1589
// module chunks = 10